import React from 'react';
import AmplifierIcon from './icons/AmplifierIcon';

const SplashScreen: React.FC = () => (
  <div className="bg-brand-dark min-h-screen flex flex-col items-center justify-center text-white">
    <div className="flex items-center text-brand-orange animate-pulse">
        <AmplifierIcon className="h-16 w-16" />
        <h1 className="text-5xl font-bold tracking-tighter ml-4">beYourAMP</h1>
    </div>
    <p className="mt-4 text-brand-muted">Igniting professional connections...</p>
  </div>
);

export default SplashScreen;